import React from "react";
import PropTypes from "prop-types";
import { List } from "immutable";
import { LoaderSkeleton } from "components";
import QueryString from "query-string";
import { STATE_STATUS } from "../constants";
import ExpandableSteps from "../components/expandable-steps";
import "styles/stage-tabs.css";
const stepStyle = {
    marginBottom: 10,
    boxShadow: "0px -1px 0 0 #e8e8e8 inset",
    overflowX: "scroll"
};

// const TabPane = Tabs.TabPane;
const StageTabsGenerator = WrappedComponent =>
    class StageTabs extends React.Component {
        state = {
            activeKeyId: null,
            stages: List([])
        };

        componentDidMount() {
            if(
                this.props.history.location && 
                this.props.history.location.search && 
                this.props.history.location.search.length > 0
            ) {
                const parsedObj = QueryString.parse(this.props.history.location.search, {
                    parseBooleans: true,
                    parseNumbers: true,
                    arrayFormat: "comma"
                });
                if(parsedObj.stage) {
                    this.setState({
                        activeKeyId: parsedObj.stage,
                        viewType: parsedObj.view,
                        docType: parsedObj.stage === 5 ? parsedObj.documents : "all"
                    });
                    return;
                } 
            }
            this.props.history.replace({
                ...history.location,
                search: `?stage=${this.props.defaultTab?.id}&view=assigned&documents=all`
            });
            this.setState({
                activeKeyId: this.props.defaultTab?.id,
                viewType: this.props.defaultTab?.id !== 17 ? "assigned" : "all",
                docType: "all"
            });
        }

        componentDidUpdate() {
            if(this.state.activeKeyId && this.props.stages && this.props.stages.data.size > 0) {
                const activeStageName = this.props.stages.getStageName(this.state.activeKeyId);
                this.actionPermissionMap = this.props.stages.getActionPermissionMap(activeStageName);
            }
            const parsedObj = QueryString.parse(this.props.history.location.search, {
                parseBooleans: true,
                parseNumbers: true,
                arrayFormat: "comma"
            });
            if((parsedObj.stage && this.state.activeKeyId !== parsedObj.stage) || (parsedObj.view && this.state.viewType !== parsedObj.view) || (parsedObj.docType && this.state.docType !== parsedObj.documents)) {
                this.setState({
                    activeKeyId: parsedObj.stage || this.state.activeKeyId,
                    viewType: parsedObj.view || this.state.viewType,
                    docType: parsedObj.documents || this.state.docType
                });
            }
        }

        onTabChange = currentStage => {
            const activeKeyId = currentStage.id;
            let activeKey = this.props.stages.getStageName(activeKeyId);
            this.actionPermissionMap = this.props.stages.getActionPermissionMap(
                activeKey
            );
            this.props.history.push({
                ...this.props.history.location,
                search: QueryString.stringify({ 
                    stage: activeKeyId, 
                    view: activeKeyId !== 17 ? "assigned" : "all",
                    documents: "all"
                })
            });
            this.setState({
                activeKeyId,
                viewType: activeKeyId !== 17 ? "assigned" : "all",
                docType: "all"
            });
        };


        onViewSelect = (viewType) => {
            const parsedObj = QueryString.parse(this.props.history.location.search, {
                parseBooleans: true,
                parseNumbers: true,
                arrayFormat: "comma"
            });
            this.props.history.push({
                ...this.props.history.location,
                search: QueryString.stringify({ 
                    stage: parsedObj.stage,
                    documents: parsedObj.documents,
                    view: viewType
                })
            });
            this.setState({
                viewType
            });
        }

        onDocumentSelect = (docType) => {
            const parsedObj = QueryString.parse(this.props.history.location.search, {
                parseBooleans: true,
                parseNumbers: true,
                arrayFormat: "comma"
            });
            this.props.history.push({
                ...this.props.history.location,
                search: QueryString.stringify({ 
                    stage: parsedObj.stage,
                    view: parsedObj.view,
                    documents: docType
                })
            });
            this.setState({
                docType
            });
        }

        render() {
            const {
                stages,
                loading,
                caseStatus,
                stagesStatus,
                WrappedComponentProps: {
                    handleSave,
                    editable,
                    ...restWrappedComponentProps
                }
            } = this.props;
            if (!this.props.defaultTab || !this.state.activeKeyId || this.props.stagesStatus !== STATE_STATUS.FETCHED) {
                return null;
            }
            const currentStage = this.props.stages.data.find(_ => _.id == this.state.activeKeyId);
            return (
                <LoaderSkeleton loading={loading}>
                    <React.Fragment>
                        <ExpandableSteps
                            className={"stage-tabs"}
                            type={"navigation"}
                            size={"small"}
                            currentStage={currentStage}
                            onTabChange={this.onTabChange}
                            style={stepStyle}
                            toggleHelp={this.props.toggleHelp}
                            options={this.props.stages.data}
                            caseCounts={this.props.caseCounts}
                        />
                        {
                            currentStage.stage_name !== "onboard" && stagesStatus === "FETCHED" ?
                                (
                                    <WrappedComponent
                                        {...restWrappedComponentProps}
                                        editable={editable}
                                        history={this.props.history}
                                        caseStatus={caseStatus}
                                        stage={currentStage.stage_name}
                                        stageId={this.state.activeKeyId}
                                        toggleHelp={this.props.toggleHelp}
                                        selectedViewType={this.state.viewType}
                                        onViewTypeSelect={this.onViewSelect}
                                        currentStage={currentStage}
                                        actionPermissionMap={this.actionPermissionMap}
                                        containDocuments={this.state.docType}
                                        onDocumentTypeSelect={this.onDocumentSelect}
                                        columns={stages
                                            .getStageColumns(currentStage.stage_name)
                                            .map(_ => {
                                                /* eslint-disable no-unused-vars */
                                                if (
                                                    editable &&
                                                    _.editable &&
                                                    _.onCellGenerator
                                                ) {
                                                    const { onCellGenerator, ...rest } = _;
                                                    return {
                                                        ..._,
                                                        onCell: onCellGenerator(handleSave)
                                                    };
                                                }
                                                return _;
                                            })}
                                    />
                                )
                                : null
                        }
                    </React.Fragment>
                </LoaderSkeleton>
            );
        }

        static propTypes = {
            loading: PropTypes.bool,
            defaultTab: PropTypes.object,
            stages: PropTypes.object,
            caseStatus: PropTypes.string,
            participatedStages: PropTypes.object,
            children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
            WrappedComponentProps: PropTypes.object,
            toggleHelp: PropTypes.bool,
            stagesStatus: PropTypes.string,
            history: PropTypes.object
        };

        static displayName = "StageTabs";
    };

export default StageTabsGenerator;
